module.exports = __webpack_public_path__ + "static/media/logo-light-color.0f01fad1.svg";